import { useGetUser } from "@mosanic/cms/Query/byId"
import { getTicketData, NewTicket } from "@mosanic/components/Ticket"
import { TextArea } from "@mosanic/fields"
import { colors } from "@mosanic/styles"
import { userIdSelector } from "@redux/auth/reducer"
import Image from "next/image"
import { lighten } from "polished"
import { useState } from "react"
import { useSelector } from "react-redux"
import styled, { css } from "styled-components"
import { StatusDot } from "../Util"

const Floating = styled.div` 
    pointer-events: all;
    position: fixed;
    z-index: 5;
    bottom:10px;
    right:10px;
    height: 200px;
    width: 50px;
`
const Action = styled.button` 
    cursor: pointer;
    width: 40px;
    height: 40px;
    border-radius: 30px;
    background-color: ${lighten(0.3, colors.util.gray.base)};
    border: none;
    box-shadow: 0 1px 10px 0 rgba(0,0,0,.2);
    font-size: 24px;
    padding: 0;
    color: white;
    overflow: hidden;

    color: #000;
    svg path {
        fill: #000;
    }
    svg {
        transform: scale(0.6);
        transform-origin: center center;
    }
        
    transition: .2s ease-out;
    &:hover {
        background-color: ${lighten(0.2, colors.util.gray.base)};
        box-shadow: 0 1px 15px 0 rgba(0,0,0,.4);
        transform: scale(1.05);
    }
    &:focus{
        outline: none;
    }
`
const Trigger = styled(Action)` 
    position: absolute;
    width: 50px;
    height: 50px;
    border-radius: 30px;
    background-color: #5b19b7;
    right: 0;
    bottom: 0;
    z-index: 20;
    color: #fff;
    background-color: ${colors.util.primary.base};
    svg path {
        fill: #fff;
    }

   ${props => props.active && css` 
        outline: none;
        background-color: ${colors.util.primary.dark};
        box-shadow: 0 3px 8px rgba(0,0,0,.5);

        & + ul {
            bottom: 55px;
            li {
                margin-bottom: 10px;
                opacity: 1;

                &:hover label {
                    opacity: 1;
                }
            }
        }
    `}
`
const List = styled.ul` 
    position:absolute;
    bottom: 0;
    right: 0;
    padding:0;
    padding-right:5px;
    margin:0;
    list-style:none;
    z-index:10;
    
    transition: .2s ease-out;
    li{
        z-index: 2;
        display: flex;
        justify-content: flex-start;
        position: relative;
        margin-bottom: -10%;
        opacity: 0;
        
        transition: .3s ease-out;

        label{
            position: absolute;
            right: 45px;
            white-space: nowrap;
            display: block;
            margin-top: 7px;
            padding: 2px 8px;
            background-color: white;
            box-shadow: 0 1px 3px rgba(0,0,0,.2);
            border-radius:3px;
            height: 24px;
            font-size: 12px;
            /* pointer-events: none; */
            opacity:0;
            
            -webkit-transition: .2s ease-out;
            -moz-transition: .2s ease-out;
            transition: .2s ease-out;
        }
    }
`
const ChatDialog = styled.div` 

`
const ChatHeader = styled.div` 
    background: ${colors.util.primary.darkest};
	border-radius: 5px 5px 0 0;
	color: #fff;
	cursor: pointer;
	padding: 10px 24px 8px;
`
const ChatName = styled.h4 `
    font-size: 12px;
    display: inline-block;
    margin-left: 10px;
    /* &:before {
        background: ${colors.util.bright.green};
        border-radius: 50%;
        content: "";
        height: 8px;
        margin: 0 8px 0 0;
        width: 8px;
    } */
`

const Chat = styled.div` 
	background: #fff;
`
const ChatHistory = styled.div` 
    height: 125px;
	padding: 8px 14px;
	overflow-y: scroll;
`
const Avatar = styled.div` 

`
const Name = styled.h5` 

`
const Content = styled.div` 

`
const Time = styled.div` 
    &::after {
        content: '';
        display: block;
        clear: both;
    }
`
const ChatMessage = styled.div` 
    margin: 10px 0;
    ${Avatar} {
        img{
            border-radius: 50%;
            transform: scale(0.9);
            transform-origin: left center;
        }
	    float: left;
    }
    ${Name} {
        float: left;
        margin-left: 5px;
        font-size: 10px;
    }
    ${Content} {
        padding-top: 22px;
        width: 100%;
        max-width: 150px;
        margin-left: 36px;
    }
    ${Time} {
        float: right;
	    font-size: 10px;
    }
`
const Label = styled.div` 
    color: ${colors.util.gray.base};
    font-size: 9px;
    margin-bottom: 5px;
    margin-right: 5px;
    text-align: right;
`
const ChatInput = styled.input` 
    border: 1px solid #ccc;
	border-radius: 3px;
	padding: 8px;
	outline: none;
	width: 100%;
`
const ChatContainer = styled.div` 
    bottom: 75px;
	font-size: 12px;
	right: 15px;
	position: fixed;
	width: 220px;
    max-height: 0;
    overflow-y: hidden;
    z-index: 3;
    transition: all ease-in-out 0.3s;
    ${props => props.active && css` 
        box-shadow: 0 3px 25px rgba(0,0,0,.4);
        max-height: none;
        overflow-y: visible;
    `}
`

const actions = [{
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="40px" viewBox="0 0 512 512"><path d="M87.49,380c1.19-4.38-1.44-10.47-3.95-14.86A44.86,44.86,0,0,0,81,361.34a199.81,199.81,0,0,1-33-110C47.65,139.09,140.73,48,255.83,48,356.21,48,440,117.54,459.58,209.85A199,199,0,0,1,464,251.49c0,112.41-89.49,204.93-204.59,204.93-18.3,0-43-4.6-56.47-8.37s-26.92-8.77-30.39-10.11a31.09,31.09,0,0,0-11.12-2.07,30.71,30.71,0,0,0-12.09,2.43L81.51,462.78A16,16,0,0,1,76.84,464a9.6,9.6,0,0,1-9.57-9.74,15.85,15.85,0,0,1,.6-3.29Z" style={{fill:"none", strokeMiterlimit:10, stroke:"currentColor",strokeLinecap:"round",strokeWidth:"32px"}}></path></svg>,
    label: 'Live Chat',
    stroke: true
},{
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="40px" viewBox="0 0 576 512"><path d="M424 160H152c-13.255 0-24 10.745-24 24v144c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24zm-8 160H160V192h256v128zm128-96h32V112c0-26.51-21.49-48-48-48H48C21.49 64 0 85.49 0 112v112h32c17.673 0 32 14.327 32 32s-14.327 32-32 32H0v112c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V288h-32c-17.673 0-32-14.327-32-32s14.327-32 32-32zm0 96v80c0 8.823-7.177 16-16 16H48c-8.823 0-16-7.177-16-16v-80c35.29 0 64-28.71 64-64s-28.71-64-64-64v-80c0-8.823 7.177-16 16-16h480c8.823 0 16 7.177 16 16v80c-35.29 0-64 28.71-64 64s28.71 64 64 64z"></path></svg>,
    label: 'Direct Ticket'
},{
    icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="40px" height="40px"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"></path></svg>,
    label: 'Whatsapp'
}]
const triggerIcon = (
    <svg xmlns="http://www.w3.org/2000/svg"  width="40px" height="40px" viewBox="0 0 512 512">
        <path d="M431,320.6c-1-3.6,1.2-8.6,3.3-12.2a33.68,33.68,0,0,1,2.1-3.1A162,162,0,0,0,464,215c.3-92.2-77.5-167-173.7-167C206.4,48,136.4,105.1,120,180.9a160.7,160.7,0,0,0-3.7,34.2c0,92.3,74.8,169.1,171,169.1,15.3,0,35.9-4.6,47.2-7.7s22.5-7.2,25.4-8.3a26.44,26.44,0,0,1,9.3-1.7,26,26,0,0,1,10.1,2L436,388.6a13.52,13.52,0,0,0,3.9,1,8,8,0,0,0,8-8,12.85,12.85,0,0,0-.5-2.7Z" style={{fill:"none", strokeMiterlimit:10, stroke:"#fff",strokeLinecap:"round",strokeWidth:"32px"}}></path>
        <path d="M66.46,232a146.23,146.23,0,0,0,6.39,152.67c2.31,3.49,3.61,6.19,3.21,8s-11.93,61.87-11.93,61.87a8,8,0,0,0,2.71,7.68A8.17,8.17,0,0,0,72,464a7.26,7.26,0,0,0,2.91-.6l56.21-22a15.7,15.7,0,0,1,12,.2c18.94,7.38,39.88,12,60.83,12A159.21,159.21,0,0,0,284,432.11" style={{fill:"none", strokeMiterlimit:10, stroke:"#fff",strokeLinecap:"round",strokeWidth:"32px"}} ></path>
    </svg>
);
export const FloatingActions = ({}) => {
    const [active, setAction] = useState('trigger')
    const [focus, setFocus] = useState(false)
    const [inputVal, setInputVal] = useState("I have a question about ..")
    const [time] = useState(new Date())
    // onBlur={() => setFocus(false)}
    const blur = () => {
        setAction('trigger')
        // setTimeout(() => {
            setFocus(false)
        // }, 100);
    }
    const openWhatsapp = () =>  window.open(`https://wa.me/31640641745?text=${inputVal}`, '_ blank')
      const userId = useSelector(userIdSelector)
    const [user] = useGetUser({_id: userId})
    return (
        <>
        <ChatContainer active={active === 'Whatsapp' || active === 'Live Chat'}>
            <ChatHeader>
                <StatusDot active={active === 'Whatsapp'} color="green" size="large"/>
                <ChatName>
                    Thijs Zijdel
                </ChatName>
            </ChatHeader>
            <Chat>
                <ChatHistory>
                    <ChatMessage>
                        <Avatar>
                            <Image 
                                src="https://mosanic-cdn.ams3.digitaloceanspaces.com/62e7a50082b1bd8d84a13845/thijszijdel.jpg" 
                                height="30px" 
                                width="30px"
                                alt="Thijs Zijdel's profile picture"
                            />
                        </Avatar>  
                        <Name>
                            Thijs Zijdel
                        </Name>   
                        <Time>
                            {time?.getHours()}:{time.getMinutes() >= 10 ? time.getMinutes() : `0${time.getMinutes()}`}
                        </Time>
                        <Content>
                            Hi there, how may i assist to you?
                        </Content>
                    </ChatMessage>
                </ChatHistory>
                {active === 'Whatsapp' && (
                    <Label>
                        *Hitting enter opens Whatsapp
                    </Label>
                )}
                <TextArea 
                    minRows={1} 
                    maxRows={4} 
                    value={inputVal} 
                    onChange={e => setInputVal(e)} 
                    onKeyUp={e => e?.keyCode === 13 ? openWhatsapp() : null} 
                />
            </Chat>
        </ChatContainer>
        <ChatContainer active={active === 'Direct Ticket'}>
            <NewTicket 
                small
                userData={{...user}}
                data={getTicketData("help")}
            />
        </ChatContainer>
        <Floating className="fab" onMouseLeave={() => active != 'trigger' ? null : setFocus(false)}>

            <Trigger className="main"  onClick={() => !focus ? setFocus(true) : setAction('trigger')} active={focus && active === 'trigger'}>
            {active === 'trigger' ? triggerIcon : actions.find(a => a.label === active)?.icon}
            </Trigger>
            
            <List>
                {actions?.map(a => (
                    <li key={a.label}>
                    <label htmlFor={a.label}>{a.label}</label>
                    <Action id={a.label} onClick={() => setAction(a.label)}>
                        {a.icon}
                    </Action>
                    </li>
                ))}

            </List>
                

        </Floating>
        </>
    )
}